// Shared mock data used across tabs

export const USERS = [
  { id: 1, name: 'Decha Wattana',  avatar: '👨‍💻', level: 12, xp: 8450, badge: '🏆' },
  { id: 2, name: 'Siriporn K.',    avatar: '👩‍🎨', level: 10, xp: 7120, badge: '⚡' },
  { id: 3, name: 'Nattapon R.',    avatar: '👨‍🔬', level:  9, xp: 6890, badge: '🔥' },
  { id: 4, name: 'Malee T.',       avatar: '👩‍💻', level:  8, xp: 5430, badge: '✨' },
  { id: 5, name: 'Krit S.',        avatar: '🧑‍🚀', level:  7, xp: 4210, badge: '💎' },
  { id: 6, name: 'Pimchanok W.',   avatar: '👩‍🏫', level:  6, xp: 3200, badge: '🌟' },
  { id: 7, name: 'Aroon B.',       avatar: '👨‍🎤', level:  5, xp: 2150, badge: '🎯' },
];

export const INIT_POSTS = [
  {
    id: 1, user: USERS[1], time: '2h ago',
    content: 'เพิ่งเรียนจบ Module 3 ของ Flutter Advanced! ขอบคุณ community ที่ช่วยตอบคำถามตลอดนะคะ 🙌',
    likes: 24, comments: 6, liked: false, tags: ['Flutter', 'LMS'],
  },
  {
    id: 2, user: USERS[2], time: '5h ago',
    content: 'ทดสอบ <strong>YOLO11-pose</strong> กับ keypoint detection บน Jetson Nano ได้ FPS ที่ 28fps แล้ว! ถือว่าโอเคมากสำหรับ edge device ครับ',
    likes: 31, comments: 9, liked: false, tags: ['ComputerVision', 'YOLO'],
  },
  {
    id: 3, user: USERS[3], time: '1d ago',
    content: 'ใครใช้ Serverpod + PostgreSQL บน production บ้างคะ? อยากรู้ว่า connection pooling ต้องตั้งค่าอะไรเพิ่มบ้างไหม สำหรับ concurrent 500 users',
    likes: 15, comments: 12, liked: false, tags: ['Backend', 'Dart'],
  },
];

export const COURSES = [
  { id: 1, title: 'Flutter Advanced UI',    emoji: '📱', bg: 'linear-gradient(135deg,#1a1e2b,#2a1a3e)', lessons: 24, done: 18, badge: 'HOT' },
  { id: 2, title: 'YOLO Computer Vision',   emoji: '🤖', bg: 'linear-gradient(135deg,#1a1e2b,#1a2e2a)', lessons: 18, done:  7, badge: 'NEW' },
  { id: 3, title: 'Serverpod & Dart Backend',emoji:'⚡', bg: 'linear-gradient(135deg,#1a1e2b,#2e1a1a)', lessons: 20, done: 20, badge: 'DONE' },
  { id: 4, title: 'PLC & HMI Systems',      emoji: '🏭', bg: 'linear-gradient(135deg,#1a1e2b,#1a2530)', lessons: 15, done:  3, badge: null },
  { id: 5, title: 'MetaTrader EA Dev',      emoji: '📈', bg: 'linear-gradient(135deg,#1a1e2b,#2e2a1a)', lessons: 12, done:  0, badge: null },
];

export const LESSONS = [
  { id: 1, title: 'Introduction to Widgets',     dur: '12 min', done: true  },
  { id: 2, title: 'State Management with GetX',  dur: '24 min', done: true  },
  { id: 3, title: 'Custom Painters & Canvas',    dur: '31 min', done: true  },
  { id: 4, title: 'Animation Controllers',        dur: '28 min', done: false, active: true },
  { id: 5, title: 'Platform Channels',            dur: '19 min', done: false },
  { id: 6, title: 'ONNX Runtime Integration',    dur: '35 min', done: false },
];

export const EVENTS = [
  { id: 1, title: 'Flutter Live Workshop',        time: 'Today, 3:00 PM',    color: '#6c63ff', day: 30 },
  { id: 2, title: 'YOLO Model Training Session',  time: 'Jun 2, 10:00 AM',   color: '#43e97b', day:  2 },
  { id: 3, title: 'Community Q&A with Mentors',   time: 'Jun 5, 7:00 PM',    color: '#f7971e', day:  5 },
  { id: 4, title: 'Hackathon: AI Projects',        time: 'Jun 14–15',         color: '#ff6b6b', day: 14 },
];

export const MEMBERS = [
  { id: 1, name: 'Decha Wattana', email: 'decha@example.com',    plan: 'Pro',   status: 'active',  joined: 'Jan 15, 2025', revenue: '฿1,490' },
  { id: 2, name: 'Siriporn K.',   email: 'siriporn@example.com', plan: 'Basic', status: 'active',  joined: 'Feb 3, 2025',  revenue: '฿490'   },
  { id: 3, name: 'Nattapon R.',   email: 'nattapon@example.com', plan: 'Pro',   status: 'active',  joined: 'Feb 28, 2025', revenue: '฿1,490' },
  { id: 4, name: 'Malee T.',      email: 'malee@example.com',    plan: 'Basic', status: 'pending', joined: 'Mar 10, 2025', revenue: '฿490'   },
  { id: 5, name: 'Krit S.',       email: 'krit@example.com',     plan: 'Pro',   status: 'banned',  joined: 'Dec 5, 2024',  revenue: '฿0'     },
];
